module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to-live"
  }, [(_vm.isLoading || !_vm.hasLoaded) ? _c('div', {
    staticClass: "to-live__loader"
  }, [_c('Loader', {
    attrs: {
      "bgColor": "#ffffff"
    }
  })], 1) : [(_vm.hasContent) ? _c('TaskOverviewUser', {
    attrs: {
      "user": _vm.user,
      "version": _vm.liveVersion,
      "showHeadline": false,
      "canEditTasks": _vm.canEditTasks,
      "canEditNotes": _vm.canEditNotes
    },
    on: {
      "editTask": _vm.setEditSubject
    }
  }) : _c('p', {
    staticClass: "to-live__empty text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks']))])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
    attrs: {
      "showModal": _vm.isSubjectModal,
      "editSubject": _vm.editSubject,
      "propIsLoading": _vm.isSubjectLoading,
      "allowDanishPreparationFactorUi": true
    },
    on: {
      "deleteSubject": _vm.deleteSubject,
      "close": _vm.closeSubjectModal,
      "updateSubject": _vm.updateSubject,
      "saveAndShowTab": _vm.saveAndShowTab
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b036b964!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/TaskOverview/TaskOverviewLive.vue
// module id = 2092
// module chunks = 1